import { render, staticRenderFns } from "./TheSnackbar.vue?vue&type=template&id=45ce7d0e"
import script from "./TheSnackbar.vue?vue&type=script&lang=js"
export * from "./TheSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports